// extracted by mini-css-extract-plugin
module.exports = {"noBottomBorderRadius":"styles_noBottomBorderRadius__rfXJM","noTopBorder":"styles_noTopBorder__Zmv6x"};